import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteChecklistMemberActions as Actions,
  DeleteChecklistMemberRequestAction as RequestAction,
} from 'store/ducks/checklistMembers';

export function* deleteChecklistMemberRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `checklist-members/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Usuário removido do Checklist com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}